import {useAlgoliaShopConfig} from "../providers/AlgoliaShopConfigProvider.tsx";

export const useTranslations = () => {
    const { tc } = useAlgoliaShopConfig();
    return tc;
};